/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LeadsEnrichmentIntegration from './LeadsEnrichmentIntegration.vue';
import { getFieldsForMapping } from 'libs/utils/metadata';

const __vue_script__ = {
    name: 'LeadsEnrichmentSettings',

    components: { LeadsEnrichmentIntegration },

    props: {
        eid: {
            type: String,
            required: true,
        },

        value: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            availableIntegrations: [],
            integrations: [],
            prospectMetadata: {},
            enrichmentConfigs: [],
            isSpotmeUser: this.$services.user.matchesRoles({ globalRole: this.$const.ROLE_SPOTME })
        };
    },

    computed: {
        innerValue: {
            get() { return this.value; },
            set(value) { return this.$emit('input', value); },
        },
    },

    async created() {
        const prospectMetadata = await this.$services.metadata.getMetadataForType(this.eid, 'prospect')
            .catch(err => {
                console.error('[LeadsEnrichmentSettings] could not get metadata', err);
                this.$notify({
                    group: 'flashes',
                    text: this.$t('leads.settings.error_metadata'),
                    type: 'error'
                });
                return {};
            });

        this.prospectMetadata = getFieldsForMapping(prospectMetadata);

        const enrichmentConfigs = await this.$services.integrations.getIntegrationConfigs(this.eid)
            .catch(err => {
                console.error('[LeadsEnrichmentSettings] could not get integration fields', err);
                return [];
            });
        this.enrichmentConfigs = enrichmentConfigs.filter(cfg => !cfg.is_reg_config);

        this.onValueChange(this.value);
    },

    methods: {
        onValueChange(value) {
            const usedIds = [];
            const integrations = [];
            for (const [_id, settings] of Object.entries(value)) {
                integrations.push({ _id, ...settings });
                usedIds.push(_id);
            }
            this.integrations = integrations;

            const available = [];
            for (const { _id, name } of this.enrichmentConfigs) {
                if (!usedIds.includes(_id) && name) {
                    available.push({ _id, name });
                }
            }
            this.availableIntegrations = available;

            this.innerValue = value;
        },

        onAddIntegration() {
            const firstAvailable = this.availableIntegrations[0];
            if (!firstAvailable) return;
            const updated = {
                ...this.innerValue,
                [firstAvailable._id]: {
                    name: firstAvailable.name,
                    url: '',
                    secret_key: '',
                    search_fields: [],
                    fields_to_populate: [],
                    integration_fields_map: {},
                },
            };
            this.onValueChange(updated);
        },

        onRemoveIntegration(keyToRemove) {
            const updated = {};
            for (const [key, value] of Object.entries(this.innerValue)) {
                if (key === keyToRemove) continue;
                updated[key] = value;
            }
            this.onValueChange(updated);
            this.$emit('input', updated);
        },

        onIntegrationChange({ _id, ...data }) {
            if (JSON.stringify(data) === JSON.stringify(this.value[_id])) return;
            const updated = {
                ...this.innerValue,
                [_id]: data,
            };
            this.$emit('input', updated);
        },

        onIntegrationIdChange({ from, to }) {
            let changed;
            const updated = {};
            for (const [key, value] of Object.entries(this.innerValue)) {
                if (key === from._id) {
                    changed = value;
                } else {
                    updated[key] = value;
                }
            }
            if (changed) {
                updated[to._id] = { ...changed, name: to.name };
            }
            this.onValueChange(updated);
            this.$emit('input', updated);
        }
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leads-enrichment-settings"},[_c('p',{staticClass:"control-hint"},[_vm._v(_vm._s(_vm.$t('leads.settings.enrichment_description')))]),_vm._l((_vm.integrations),function(item,index){return _c('div',{key:item._id,staticClass:"integration"},[_c('leads-enrichment-integration',{attrs:{"eid":_vm.eid,"available-integrations":_vm.availableIntegrations,"integration-config":_vm.enrichmentConfigs.find(function (d) { return d._id === item._id; }),"integration-index":index,"prospect-metadata":_vm.prospectMetadata,"value":item},on:{"change":_vm.onIntegrationChange,"delete":_vm.onRemoveIntegration,"id-change":_vm.onIntegrationIdChange,"save-settings":function($event){return _vm.$emit('save-settings')}}})],1)}),(_vm.isSpotmeUser && _vm.availableIntegrations.length)?_c('button',{staticClass:"btn btn-icon",attrs:{"type":"button"},on:{"click":_vm.onAddIntegration}},[_c('i',{staticClass:"icon-plus"}),_vm._v(_vm._s(_vm.$t('leads.settings.add_integration')))]):_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LeadsEnrichmentSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__